<template>
  <div class="repayment-container">
    <!-- 悬浮头部 -->
    <div class="sticky-header">
      <header class="header">
        <p class="header-title">My Loan</p>
        <button
          class="header-button"
          @click="goRolloverPae()"
          v-if="repayment.dueDate != null && repayment.remainAmount != null"
        >
          Extension Payment
        </button>
      </header>

      <!-- 悬浮状态卡片 -->
      <div
        class="card status-card"
        style="margin-top: 10px"
        v-if="repayment.dueDate != null"
      >
        <div
          class="status-indicator"
          :class="repayment.remainingDays > 0 ? 'on-time' : 'overdue'"
        >
          <span class="days-count">{{
            Math.abs(repayment.remainingDays)
          }}</span>
          <span class="days-label">{{
            repayment.remainingDays > 0 ? "Remaining days" : "Days overdue"
          }}</span>
        </div>

        <div class="status-details">
          <div class="detail-item">
            <span class="detail-value"
              >${{ formatAmount(repayment.remainAmount, 0, ".", ".") }}</span
            >
            <span class="detail-label">Amount to pay</span>
          </div>
          <div class="detail-item">
            <span class="detail-value">{{
              formatDate(repayment.dueDate)
            }}</span>
            <span class="detail-label">Due date</span>
          </div>
        </div>
      </div>

      <!-- Loan closed message -->
      <div
        class="card status-card loan-closed-card"
        style="margin-top: 10px; text-align: center;"
        v-if="loanClosed"
      >
        <div class="loan-closed-message">
          <p style="font-size: 16px; font-weight: 700; margin-bottom: 6px; color: #0A192F;">
            Loan successfully closed
          </p>
          <p style="font-size: 14px; color: #64748B; margin: 0;">
            You can apply for a higher amount next time.
          </p>
        </div>
      </div>
    </div>

    <main class="content">
      <!-- 贷款详情卡片 -->
      <div
        class="card info-card"
        v-if="!(repayment.dueDate == null && repayment.remainAmount == null)"
      >
        <div class="info-row">
          <span>Móvil</span>
          <span
            >***
            {{ repayment.phone.substr(5, repayment.phone.length - 1) }}</span
          >
        </div>

        <div class="info-row">
          <span>Status</span>
          <span class="status-badge">Prepare to pay</span>
        </div>

        <div class="info-row">
          <span>Account holder:</span>
          <span>{{ repayment.titular }}</span>
        </div>

        <!-- Pay now button -->
        <div style="margin-top: 20px; text-align: center;">
          <button
            class="primary-btn"
            @click="copyCLABE"
            style="width: 100%; max-width: 320px;"
          >
            Pay now →
          </button>
        </div>
      </div>

      <!-- 无到期日时的卡片 -->
      <div
        class="card advice-card"
        v-if="repayment.dueDate == null && repayment.remainAmount != null"
      >
        <p class="advice-text">
          Maintain and take care of your credit, it would avoid an extra charge
          for the delay. We suggest making the payment with the following
          accounts:
        </p>
        <div class="info-row">
          <span>Account holder:</span>
          <span>{{ repayment.titular }}</span>
        </div>
      </div>

      <!-- Safe Repayment Reminder -->
      <div
        class="card warning-card"
        v-if="!(repayment.dueDate == null && repayment.remainAmount == null)"
      >
        <div style="display: flex; align-items: flex-start;">
          <span class="warning-icon">⚠️</span>
          <div>
            <p class="warning-title">
              Safe Repayment Reminder
            </p>
            <p class="warning-desc">
              Always repay using the UPIID shown in this App.
            </p>
            <p class="warning-desc" style="margin-bottom: 0;">
              Do NOT trust any UPIID shared in WhatsApp or personal messages.
            </p>
          </div>
        </div>
      </div>

      <!-- UTR Input Section -->
      <div
        class="card utr-card"
        v-if="!(repayment.dueDate == null && repayment.remainAmount == null)"
      >
        <div class="utr-input-container">
          <label class="utr-label">Enter UTR Number</label>
          <p class="utr-desc">
            After completing payment, please enter your 12-digit UTR(UPI Ref.
            No.) below ↓
          </p>
          <div class="input-wrapper">
            <input
              v-model="utr"
              class="utr-input"
              type="text"
              placeholder="Enter 12-digit UTR number"
              maxlength="12"
            />
            <button class="paste-btn" @click="pasteUTR">Paste</button>
          </div>
          <div class="error-message" v-if="utr && !isValidUTR()">
            Please enter a valid 12-digit UTR number
          </div>

          <!-- Success message - only shown after successful submission -->
          <div class="success-message" v-if="utrSubmitted && utrSuccessMessage">
            {{ utrSuccessMessage }}
          </div>

          <button
            class="submit-utr-btn"
            @click="submitUTR"
            :disabled="!isValidUTR()"
          >
            Submit UTR →
          </button>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import CallApp from "callapp-lib";

export default {
  name: "Repayment",
  data() {
    return {
      repayment: {},
      bankMethods: {},
      repaymentCode: null,
      key: "",
      clabe: null,
      instance: null,
      showBankSelection: false,
      expandedCategories: {},
      utr: "",
      utrSubmitted: false,
      utrSuccessMessage: "",
      loanClosed: false,
    };
  },
  mounted() {
    document.title = "My Loan";
  },
  created() {
    this.getDetailInfo();
  },
  methods: {
    formatDate(dateStr) {
      return dateStr ? dateStr.substr(0, 10) : "";
    },

    penaltyWaiver() {
      if (this.repayment.penaltyUrl) {
        window.open(this.repayment.penaltyUrl, "_blank");
        let keyStr = this.getParamQueryString(window.location.href, "key");
        this.$Http.pointH5Report(
          {
            key: keyStr,
            eventName: "open_penalty_waiver",
          },
          true,
        );
      }
    },
    formatAmount(
      amount,
      decimals = 2,
      decimalSeparator = ".",
      thousandSeparator = ",",
    ) {
      amount = Number(amount);
      if (isNaN(amount)) {
        return "";
      }
      const factor = Math.pow(10, decimals);
      amount = Math.round(amount * factor) / factor;
      let amountStr = amount.toFixed(decimals);
      const [integerPart, decimalPart] = amountStr.split(".");
      const integerPartWithSeparator = integerPart.replace(
        /\B(?=(\d{3})+(?!\d))/g,
        thousandSeparator,
      );
      return (
        integerPartWithSeparator +
        (decimalPart ? decimalSeparator + decimalPart : "")
      );
    },
    async getDetailInfo() {
      let keyStr = this.getParamQueryString(window.location.href, "key");
      let res = await this.$Http.getRepaymentInfo({ key: keyStr }, true);
      this.repayment = res;

      if (res.dueDate == null && res.remainAmount == null) {
        this.loanClosed = true;
      }

      try {
        let bankRes = await this.$Http.repaymentMethod({ key: keyStr });
        this.bankMethods = {
          "Payment Methods": Object.keys(bankRes).map((key) => ({
            repayCode: key,
            repayMethodName: key,
            selected: bankRes[key],
          })),
        };
        Object.keys(bankRes).map((key) => {
          if (bankRes[key]) {
            this.repaymentCode = key;
          }
        });
        this.initExpandedState();
      } catch (error) {
        console.error("Error fetching bank methods:", error);
      }
    },
    getParamQueryString(url, name) {
      let subStr = name + "=";
      if (url.indexOf(subStr) !== -1) {
        let arr = url.split(subStr);
        let sub1 = arr[1];
        if (sub1.indexOf("&") !== -1) {
          let arr2 = sub1.split("&");
          return arr2[0];
        }
        return sub1;
      }
      return "";
    },
    goRolloverPae() {
      let keyStr = this.getParamQueryString(window.location.href, "key");
      this.$router.push({ path: "/rollover", query: { key: keyStr } });
    },
    async copyCLABE() {
      try {
        let keyStr = this.getParamQueryString(window.location.href, "key");
        let responseInfo = await this.$Http.repaymentUrl(
          {
            key: keyStr,
            repayCode: this.repaymentCode,
          },
          false,
        );
        if (responseInfo && responseInfo.length > 0) {
          window.open(responseInfo, "_blank");
        }
        await this.$Http.pointH5Report(
          {
            key: keyStr,
            eventName: "click_pay_button",
          },
          true,
        );
      } catch (error) {
        console.error("Error:", error);
      }
    },
    initExpandedState() {
      const categories = Object.keys(this.bankMethods);
      let selectedCategory = null;
      selectedCategory = categories[0];

      categories.forEach((category) => {
        const methods = this.bankMethods[category];
        const hasSelected = methods.some((method) => method.selected);
        if (hasSelected) {
          selectedCategory = category;
        }
      });

      categories.forEach((category) => {
        this.$set(this.expandedCategories, category, false);
      });

      if (selectedCategory) {
        this.$set(this.expandedCategories, selectedCategory, true);
        this.lastExpandedCategory = selectedCategory;
      } else if (categories.length > 0) {
        this.$set(this.expandedCategories, categories[0], true);
        this.lastExpandedCategory = categories[0];
      }
    },
    toggleCategory(category) {
      if (this.expandedCategories[category]) {
        this.$set(this.expandedCategories, category, false);
        this.lastExpandedCategory = null;
      } else {
        if (this.lastExpandedCategory) {
          this.$set(this.expandedCategories, this.lastExpandedCategory, false);
        }
        this.$set(this.expandedCategories, category, true);
        this.lastExpandedCategory = category;
      }
    },
    selectMethod(method) {
      Object.keys(this.bankMethods).forEach((category) => {
        this.bankMethods[category].forEach((m) => {
          this.$set(m, "selected", false);
        });
      });

      this.$set(method, "selected", true);
      this.repaymentCode = method.repayCode;
      const bankName = method.repayMethodName.includes("-")
        ? method.repayMethodName.split("-")[0]
        : method.repayMethodName;
      this.repayment.repaymentBankName = bankName;
      this.showBankSelection = false;
    },
    isValidUTR() {
      return /^\d{12}$/.test(this.utr);
    },
    async pasteUTR() {
      try {
        const text = await navigator.clipboard.readText();
        if (/^\d{12}$/.test(text)) {
          this.utr = text;
        } else {
          this.utr = text;
        }
      } catch (err) {
        console.error("Failed to read clipboard contents: ", err);
      }
    },
    async submitUTR() {
      if (!this.isValidUTR()) {
        return;
      }

      try {
        let keyStr = this.getParamQueryString(window.location.href, "key");
        let response = await this.$Http.submitUrl(
          {
            key: keyStr,
            utr: this.utr,
            isExtend: false,
          },
          true,
        );

        console.log("UTR submitted successfully", response);

        if (this.$toast) {
          this.$toast.success("Success");
        } else {
          alert("Success");
        }

        if (response && response.loanClosed) {
          this.loanClosed = true;
          if (this.$toast) {
            this.$toast.success(
              "Loan successfully closed. You can apply for a higher amount next time.",
            );
          }
        } else if (
          response &&
          response.dueDate == null &&
          response.remainAmount == null
        ) {
          this.loanClosed = true;
          if (this.$toast) {
            this.$toast.success(
              "Loan successfully closed. You can apply for a higher amount next time.",
            );
          }
        }

        this.utrSubmitted = true;
        this.utrSuccessMessage =
          response.message || "UTR submitted successfully!";
      } catch (error) {
        console.error("Error submitting UTR:", error);
        this.utrSubmitted = false;
        this.utrSuccessMessage = "";

        if (this.$toast) {
          this.$toast.fail("Failed to submit UTR");
        }
      }
    },
  },
};
</script>

<style scoped>
/* 基础容器：暖米白质感背景 */
.repayment-container {
  min-height: 100vh;
  background-color: #FAF8F5;
  color: #0A192F;
  padding-bottom: 40px;
}

/* 悬浮头部区域 */
.sticky-header {
  position: sticky;
  top: 0;
  z-index: 100;
  background-color: transparent;
}

/* 头部样式：深海夜空渐变 Header */
.header {
  background: linear-gradient(135deg, #0A192F 0%, #050D1A 100%);
  color: #FFFFFF;
  padding: 18px 20px 48px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 0 0 24px 24px;
  box-shadow: 0 10px 30px rgba(10, 25, 47, 0.2);
}

.header-title {
  font-size: 20px;
  font-weight: 700;
  flex: 1;
  text-align: left;
  letter-spacing: -0.3px;
  margin: 0;
  color: #FFFFFF;
}

.header-button {
  background: rgba(212, 175, 55, 0.15);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border: 1px solid rgba(212, 175, 55, 0.4);
  color: #D4AF37;
  font-size: 13px;
  font-weight: 700;
  padding: 7px 14px;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.header-button:active {
  transform: scale(0.95);
  background: rgba(212, 175, 55, 0.3);
}

/* 卡片通用样式：纯白高品质卡片 + 柔和弥散阴影 */
.card {
  background: #FFFFFF;
  border-radius: 20px;
  padding: 20px;
  max-width: 600px;
  box-shadow: 0 10px 30px rgba(10, 25, 47, 0.07), 0 2px 8px rgba(0, 0, 0, 0.03);
  border: 1px solid rgba(10, 25, 47, 0.05);
  margin: 0 16px 16px;
  flex-direction: column;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

/* 状态卡片 (浮动在Header下方) */
.status-card {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 20px;
  background: #FFFFFF;
  color: #0A192F;
  margin-top: -36px;
  position: relative;
  z-index: 10;
  box-shadow: 0 12px 32px rgba(10, 25, 47, 0.12), 0 2px 8px rgba(0, 0, 0, 0.04);
}

.status-indicator {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 16px 0 4px;
  border-right: 1px solid #EAEFF5;
  min-width: 105px;
}

.days-count {
  font-size: 32px;
  font-weight: 800;
  line-height: 1;
  color: #C59B27;
  letter-spacing: -0.5px;
}

.days-label {
  font-size: 12px;
  margin-top: 6px;
  color: #64748B;
  font-weight: 600;
}

.status-details {
  width: 100%;
  display: flex;
  justify-content: space-around;
}

.detail-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.detail-value {
  font-size: 17px;
  font-weight: 700;
  color: #0A192F;
  margin-bottom: 4px;
  margin-top: 4px;
}

.detail-label {
  font-size: 12px;
  color: #94A3B8;
  font-weight: 500;
}

/* 内容区域 */
.content {
  padding-bottom: 120px;
  max-width: 600px;
  margin: 0 auto;
}

/* 信息卡片 */
.info-card {
  padding: 20px;
  margin: 16px 16px 0;
}

.info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 16px;
  background-color: #F4F6F9;
  border-radius: 14px;
  margin-bottom: 10px;
  border: 1px solid #EAEFF5;
  font-size: 14px;
  color: #64748B;
  font-weight: 500;
}

.info-row span:last-child {
  font-weight: 700;
  color: #0A192F;
}

.status-badge {
  background-color: rgba(212, 175, 55, 0.12);
  color: #B88B14;
  border: 1px solid rgba(212, 175, 55, 0.3);
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 700;
}

/* 建议卡片 & 提醒卡片 */
.advice-card {
  padding: 20px;
  margin: 0 16px 16px;
}

.advice-text {
  margin-bottom: 14px;
  line-height: 1.5;
  color: #64748B;
  font-size: 14px;
}

.warning-card {
  padding: 18px 20px;
  margin: 16px 16px 16px;
  background: #FFFDF6 !important;
  border: 1px solid rgba(212, 175, 55, 0.35) !important;
  border-radius: 16px !important;
}

.warning-icon {
  font-size: 18px;
  color: #D4AF37;
  margin-right: 10px;
}

.warning-title {
  font-weight: 700;
  margin: 0 0 6px 0;
  color: #0A192F;
  font-size: 15px;
}

.warning-desc {
  margin: 0 0 4px 0;
  font-size: 13px;
  color: #64748B;
  line-height: 1.4;
}

/* UTR Input Styles */
.utr-card {
  padding: 20px;
  margin: 0 16px 20px;
}

.utr-label {
  display: block;
  font-size: 17px;
  font-weight: 700;
  margin-bottom: 6px;
  color: #0A192F;
}

.utr-desc {
  font-size: 13px;
  color: #64748B;
  margin: 0 0 14px 0;
  line-height: 1.4;
}

.input-wrapper {
  display: flex;
  gap: 10px;
  margin-bottom: 14px;
}

.utr-input {
  flex: 1;
  padding: 12px 16px;
  background-color: #F4F6F9;
  border: 1px solid #EAEFF5;
  border-radius: 14px;
  font-size: 15px;
  outline: none;
  color: #0A192F;
  font-weight: 600;
  transition: all 0.2s;
}

.utr-input:focus {
  border-color: #D4AF37;
  background-color: #FFFFFF;
  box-shadow: 0 0 0 3px rgba(212, 175, 55, 0.18);
}

.utr-input::placeholder {
  color: #94A3B8;
  font-weight: normal;
}

.paste-btn {
  background-color: #0A192F;
  border: none;
  border-radius: 12px;
  padding: 0 18px;
  font-size: 14px;
  font-weight: 700;
  color: #D4AF37;
  cursor: pointer;
  transition: all 0.2s;
}

.paste-btn:active {
  transform: scale(0.95);
  opacity: 0.9;
}

.error-message {
  color: #EF4444;
  font-size: 13px;
  margin-bottom: 12px;
  font-weight: 600;
}

.success-message {
  color: #10B981;
  font-size: 13px;
  margin-bottom: 12px;
  font-weight: 600;
}

/* 主行动按钮：深藏青渐变底 + 金色加粗文字 */
.primary-btn,
.submit-utr-btn {
  width: 100%;
  background: linear-gradient(135deg, #0A192F 0%, #050D1A 100%);
  color: #D4AF37;
  border: none;
  border-radius: 16px;
  padding: 15px;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.25s cubic-bezier(0.16, 1, 0.3, 1);
  box-shadow: 0 8px 24px rgba(10, 25, 47, 0.22);
  letter-spacing: 0.3px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.primary-btn:hover,
.submit-utr-btn:hover:not(:disabled) {
  box-shadow: 0 10px 28px rgba(10, 25, 47, 0.32);
  transform: translateY(-1px);
}

.primary-btn:active,
.submit-utr-btn:active:not(:disabled) {
  transform: scale(0.98);
  opacity: 0.92;
}

.submit-utr-btn:disabled {
  background: #E2E8F0;
  color: #94A3B8;
  box-shadow: none;
  cursor: not-allowed;
}

/* 响应式设计 */
@media (max-width: 480px) {
  .status-card {
    flex-direction: row;
  }
}
</style>
